// extracted by mini-css-extract-plugin
export default {"wrapper":"Schedule_wrapper__hzSYp"};